import * as React from "react";
import Dialog from "../Dialog/Dialog";
import {withRouter} from "react-router-dom";
import {URLs} from "../../../util/Constants";

export class SessionTimer extends React.Component<any, any> {

  toMillisOperator = 60000;
  timeoutWarningInMinutes = 5;
  timeoutInMinutes = 20;

  constructor(props: any) {
    super(props);
    this.closeModalHandler = this.closeModalHandler.bind(this);
    this.state = {
      oldDate: new Date().getTime(),
      lastActive: new Date().getTime(),
      remaining: undefined,
      pageX: undefined,
      warnTimeoutId: undefined,
      closeTimeoutId: undefined,
      closeTimeout: this.timeoutInMinutes * this.toMillisOperator,
      warnTimeout: this.timeoutWarningInMinutes * this.toMillisOperator,
      elapsedTime: 0,
      showModal: false,
      events: [
        "mousemove",
        "keydown",
        "wheel",
        "DOMMouseScroll",
        "mouseWheel",
        "mousedown",
        "touchstart",
        "touchmove",
        "MSPointerDown",
        "MSPointerMove",
      ],
    };
  }

  componentWillMount() {
    this.state.events.forEach(e => window.addEventListener(e, () => {
      this.handleEvent(e);
    }));
  }

  componentDidMount() {
    this.reset();

    const checkInterval = 1000;
    setInterval(() => {
      this.setState({
        remaining: this.getRemainingTime(),
        lastActive: this.getLastActiveTime(),
        elapsedTime: this.getElapsedTime(),
      });
    }, checkInterval);
  }

  render() {
    const closeSessionTime = this.state.warnTimeout / this.toMillisOperator;
    return (
      <div>
        {this.state.showModal &&
        <Dialog
          title={"Aviso de inactividad"}
          icon={"alert-triangle"}
          confirmBtnText={"Cerrar"}
          onCancel={this.closeModalHandler}
          onConfirm={this.closeModalHandler}>
          <span>La sesi&oacute;n se cerrar&aacute; en {closeSessionTime} minutos por inactividad</span>
        </Dialog>
        }
      </div>
    );
  }

  warnUser() {
    this.setState({
      showModal: true,
    });
  }

  closeModalHandler() {
    this.setState({
      showModal: false,
    });
  }

  goToHome() {
    this.props.history.push(URLs.HOME);
  }

  handleEvent(e: any) {
    // Mousemove event
    if (e.type === "mousemove") {
      // if coord are same, it didn't move
      if (e.pageX === this.state.pageX && e.pageY === this.state.pageY) {
        return;
      }
      // if coord don't exist how could it move
      if (typeof e.pageX === "undefined" && typeof e.pageY === "undefined") {
        return;
      }
      // under 200 ms is hard to do, and you would have to stop, as continuous activity will bypass this
      const elapsed = new Date().getTime() - this.state.oldDate;
      const minimumInterval = 200;
      if (elapsed < minimumInterval) {
        return;
      }
    }

    // clear any existing timeout
    clearTimeout(this.state.warnTimeoutId);
    clearTimeout(this.state.closeTimeoutId);

    this.setState({
      lastActive: new Date().getTime(),
      pageX: e.pageX,
      pageY: e.pageY,
      warnTimeoutId: setTimeout(this.warnUser.bind(this), this.state.closeTimeout - this.state.warnTimeout),
      closeTimeoutId: setTimeout(this.goToHome.bind(this), this.state.closeTimeout),
    });

  }

  reset() {
    clearTimeout(this.state.warnTimeoutId);
    clearTimeout(this.state.closeTimeoutId);

    const warnTimeoutId = setTimeout(this.warnUser.bind(this), this.state.closeTimeout - this.state.warnTimeout);
    const closeTimeoutId = setTimeout(this.goToHome.bind(this), this.state.closeTimeout);

    const newState = {
      warnTimeoutId,
      closeTimeoutId,
      oldDate: new Date().getTime(),
      lastActive: this.state.oldDate,
      remaining: undefined,
    };

    this.setState(newState);
  }

  getRemainingTime() {
    let remaining = this.state.closeTimeout - (new Date().getTime() - this.state.lastActive);
    if (remaining < 0) {
      remaining = 0;
    }
    return remaining;
  }

  getElapsedTime() {
    return new Date().getTime() - this.state.oldDate;
  }

  getLastActiveTime() {
    return this.state.lastActive;
  }

}

export default withRouter(SessionTimer);
